var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentWithHeader", {
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c(
              "button",
              {
                staticClass: "btn no-bg",
                on: {
                  click: function($event) {
                    return _vm.setPosSection("choose-product")
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-times" })]
            )
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c("div", { staticClass: "wrapper" }, [
              _c("div", { staticClass: "col-12 mt-4 mb-1 status" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("message.discount")) + "\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "col-12 no-padding items" },
                _vm._l(_vm.filterDiscounts, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "row no-margin item",
                      on: {
                        click: function($event) {
                          return _vm.onSelectItem(item)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between col" },
                        [
                          _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.discount_name) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            item.value_type == "percentage"
                              ? _c("span", [
                                  _vm._v(_vm._s(item.value_amount) + "%")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.value_type == "number"
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.getNumber(item.value_amount)) +
                                      " " +
                                      _vm._s(_vm.currency)
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-369b0da3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-369b0da3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/mobile/include/DiscountList.vue
// module id = null
// module chunks = 